import './bootstrap'
import { Collapse } from 'bootstrap'
import cleave from 'cleave.js'
import slideout from 'slideout'
import swal from 'sweetalert'
import { tns } from 'tiny-slider/src/tiny-slider'

/**
 * Condense header on scroll.
 */
window.addEventListener('scroll', () => {
  const scrollTop = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset
  const body = document.querySelector('body')

  let scrollTrigger = document.querySelector('.app-header').clientHeight

  // Home page
  if (body.classList.contains('page-home')) {
    scrollTrigger = 10
  }

  if (scrollTop >= scrollTrigger) {
    body.classList.add('header-condensed')
  } else {
    body.classList.remove('header-condensed')
  }
})

/**
 * Disable form submit buttons on submission.
 */
document.querySelectorAll('form').forEach(form => {
  form.addEventListener('submit', e => {
    form.querySelector('button[type="submit"]').disabled = true
  }, false)
})

/**
 * Scroll to element.
 */
const scrollToElements = document.querySelectorAll('[data-scroll-to]')
for (const scrollToElement of scrollToElements) {
  scrollToElement.addEventListener('click', e => {
    e.preventDefault()

    const selector = e.target.dataset.scrollTo

    let 
      mainMarginTopOffset = 88,
      headerHeightOffset = 88,
      extaSpacing = 10,
      offsetTop = document.querySelector(selector).offsetTop

    // Space for the top margin and header
    if (window.outerWidth >= 992 && window.outerWidth < 1200) {
      mainMarginTopOffset = 121
      headerHeightOffset = 121

    } else if (window.outerWidth >= 1200 && window.outerWidth < 1400) {
      mainMarginTopOffset = 121
      headerHeightOffset = 121

    } else if (window.outerWidth >= 1400 && window.outerWidth < 1620) {
      mainMarginTopOffset = 167
      headerHeightOffset = 167

    } else if (window.outerWidth >= 1620) {
      mainMarginTopOffset = 323
      headerHeightOffset = 203
    }

    offsetTop = (offsetTop + mainMarginTopOffset - headerHeightOffset - extaSpacing)

    scroll({
      top: offsetTop,
      behavior: 'smooth',
    })
  })
}

/**
 * Slideshow.
 * @see https://github.com/ganlanyuan/tiny-slider
 */
if (document.querySelector('.slideshow .slides')) {
  const slider = tns({
    container: '.slideshow .slides',
    items: 1,
    mode: 'gallery',
    slideBy: 'page',
    autoplay: true,
    autoplayButtonOutput: false,
    controls: false,
    nav: false,
    mouseDrag: true,
    responsive: {
      768: {
        nav: true
      }
    }
  })
}

/**
 * Slideout Nav.
 * @see https://github.com/mango/slideout
 */
const slideoutNav = new slideout({
  panel: document.getElementById('app-panel'),
  menu: document.getElementById('app-nav-mobile'),
  padding: 320,
  tolerance: 70,
  side: 'right',
  touch: false
})

document.querySelectorAll('.nav-icon').forEach(navIcon => {
  navIcon.addEventListener('click', () => {
    slideoutNav.toggle()
  })
})

document.querySelector('#app-nav-mobile .btn-close').addEventListener('click', () => {
  slideoutNav.close()
})

/**
 * Mask phone inputs.
 */
Array.from(document.querySelectorAll('input[type="tel"]')).forEach(el => {
  new cleave(el, {
    numericOnly: true,
    blocks: [0, 3, 0, 3, 4],
    delimiters: ["(", ")", " ", "-"],
  })
})

/**
 * Mask numeric inputs.
 */
Array.from(document.querySelectorAll('input.numeric, input.currency, input.percentage')).forEach(el => {
  new cleave(el, {
    numeral: true,
    numeralThousandsGroupStyle: 'thousand',
    numeralDecimalScale: 2,
  })
})

/**
 * Modals.
 *
 * Appends the Bootstrap modal backdrop to the app panel
 * so that it is under the modal itself.
 */
const modals = document.querySelectorAll('.modal')
modals.forEach(modal => {
  modal.addEventListener('show.bs.modal', e => {
    const backdrop = document.createElement('div')
    backdrop.classList.add('modal-backdrop', 'fade', 'show')
    document.querySelector('#app-panel').appendChild(backdrop)
  })

  modal.addEventListener('hidden.bs.modal', e => {
    const backdrop = document.querySelector('.modal-backdrop')
    backdrop.parentNode.removeChild(backdrop)
  })
})

/**
 * Submit forms via AJAX.
 *
 * @param  {object}  form
 */
window.ajaxForm = function(form) {
  form.querySelector('button[type="submit"]').disabled = true

  const formAction = form.getAttribute('action')

  const formData = new FormData(form)
  const entries = formData.entries()
  const data = Object.fromEntries(entries)

  axios({
    method: 'post',
    url: formAction, 
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    }
  })
  .then(function(response) {
    form.querySelector('button[type="submit"]').disabled = false

    if (response.data.success) {
      let msg = document.createElement('div')
      msg.innerHTML = '<div class="alert alert-success">' + (response.data.message || 'Thank you! Your information has been received successfully.') + '</div>'
      form.replaceWith(msg)
    } else {
      swal('An error occurred.', response.data.message || '')
    }
  })
  .catch(function(error) {
    form.querySelector('button[type="submit"]').disabled = false

    if (error.response.data.errors) {
      let errors = []
      for (let e in error.response.data.errors) {
        errors.push(error.response.data.errors[e][0])
      }

      let div = document.createElement('div');
      div.innerHTML = '<ul class="alert alert-danger text-start"><li>' + errors.join('</li><li>') + '</li></ul>'
      swal({
        icon: 'error',
        content: div
      });
    } else {
      swal('An unexpected error occurred.')
    }
  })
}

/**
 * Initialize reCaptcha v3.
 *
 * @param  {String}  verifyUrl  The token verification URL
 * @param  {String}  siteKey    reCaptcha site key
 * @param  {String}  viewName   Laravel view name
 */
window.initReCaptcha = function(verifyUrl, siteKey, viewName) {

  // Page load.
  grecaptcha.execute(siteKey, {action: 'pageload/' + viewName})
    .then(token => {
      axios.post(verifyUrl, {token: token, action: 'pageload/' + viewName})
        .then(response => {
          // Success
        })
        .catch(error => {
          console.log(error);

          document.querySelectorAll('form:not(.nocaptcha)').forEach(form => {
            form.parentNode.removeChild(form)
          })
        })
    })

  // Form submission.
  const forms = document.querySelectorAll('form:not(.nocaptcha):not(.noajax)')
  forms.forEach(form => {
    form.addEventListener('submit', e => {

      if (! form.querySelector('input[name="captcha_token"]')) {
        e.preventDefault()

        form.querySelector('button[type="submit"]').disabled = true

        grecaptcha.execute(siteKey, {action: 'formsubmission/' + viewName})
          .then(token => {
            let tokenInput = document.createElement('input')
            tokenInput.type = 'hidden'
            tokenInput.name = 'captcha_token'
            tokenInput.value = token
            form.appendChild(tokenInput)

            let actionInput = document.createElement('input')
            actionInput.type = 'hidden'
            actionInput.name = 'captcha_action'
            actionInput.value = 'formsubmission/' + viewName
            form.appendChild(actionInput)

            //form.submit()
            ajaxForm(form)

          }, error => {
            console.log(error)
          })
      }
    })
  })
}
